import { useInitialSort } from "ds/components/Table/hooks/useInitialSort";
import TableSimple from "ds/components/TableSimple";
import useErrorHandle from "hooks/useErrorHandle";

import SpaceliftVcsRepoUsedByEmpty from "./Empty";
import SPACELIFT_VCS_REPO_USED_BY_TABLE_CELLS from "./Table/Cells";
import {
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
  ITEMS_LIMIT,
  SORT_STORAGE_KEY,
} from "./Table/constants";
import useSpaceliftVcsRepoUsedByTableStore from "./Table/useTableStore";
import useSpaceliftVcsRepoUsedBySearchUsedStacks from "./useSearchUsedStacks";

type SpaceliftVcsRepoUsedByProps = {
  stackIDs: string[];
};

const SpaceliftVcsRepoUsedBy = ({ stackIDs }: SpaceliftVcsRepoUsedByProps) => {
  useInitialSort(INITIAL_SORT_OPTION, INITIAL_SORT_DIRECTION);

  const { items, loading, hasMore, isEmpty, loadMore, error } =
    useSpaceliftVcsRepoUsedBySearchUsedStacks(stackIDs);

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (isEmpty) {
    return <SpaceliftVcsRepoUsedByEmpty />;
  }

  return (
    <TableSimple
      data={items}
      loading={loading}
      store={useSpaceliftVcsRepoUsedByTableStore}
      filtersStorageKey={SORT_STORAGE_KEY}
      ariaLabel="Stacks using this repository"
      onLoadMore={hasMore ? loadMore : undefined}
      cellPerColumn={SPACELIFT_VCS_REPO_USED_BY_TABLE_CELLS}
      hasPagination={false}
      virtualize={items.length >= ITEMS_LIMIT}
    />
  );
};

export default SpaceliftVcsRepoUsedBy;
